import { fetchWrapper } from '@/_helpers';

export function getAggregate(team) {
    const qs = team ? `?team=${team}` : '';
    return fetchWrapper.get(`staff-turnover/aggregate${qs}`);
}

export function getStaff({ team, page, limit, sortBy } = {}) {
    const params = new URLSearchParams();
    if (team) params.append('team', team);
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (sortBy) params.append('sortBy', sortBy);
    const qs = params.toString();
    return fetchWrapper.get(`staff-turnover/staff${qs ? '?' + qs : ''}`);
}
